import { formatBytes, formatDuration } from './format';
import type { TransferProgress } from '../transfer/types';

export function buildTransferReceipt(progress: TransferProgress): string {
  if (progress.state !== 'complete') throw new Error('A receipt is available only after verified completion.');
  const direction = progress.direction === 'sending' ? 'Sent' : 'Received';
  const completedAt = new Date(progress.completedAt ?? Date.now()).toISOString();
  return [
    'PairFerry — verified transfer receipt',
    'Status: Verified complete',
    `Direction: ${direction}`,
    `Files: ${progress.fileCount}`,
    `Total: ${formatBytes(progress.totalBytes)} (${progress.totalBytes} bytes)`,
    `Duration: ${formatDuration(progress.elapsedSeconds)}`,
    `Average speed: ${formatBytes(progress.bytesPerSecond)}/s`,
    `Completed: ${completedAt}`,
    'Privacy: This receipt intentionally excludes filenames, paths, invitation data, and IP addresses.',
  ].join('\n');
}
